import classNames from 'classnames';
import React from 'react';
import { primaryGray } from '../../Styles/Colours';
import { Button, ButtonMode } from '../Button';
import { ArrowLeftIcon } from '../Icons';
import styles from './StyledDialog.module.css';
export var SidePanelSizes;
(function (SidePanelSizes) {
    SidePanelSizes[SidePanelSizes["Small"] = 0] = "Small";
    SidePanelSizes[SidePanelSizes["Normal"] = 1] = "Normal";
})(SidePanelSizes || (SidePanelSizes = {}));
export var DialogSidebar = function (props) {
    var _a, _b, _c;
    var collapsed = props.preventSideBarCollapse ? false : props.collapsed;
    var sidebarClass = classNames(styles.sidebar, (_a = {},
        _a[styles.sidebarClosed] = collapsed,
        _a[styles.sideBarSmall] = props.sidePanelSize === SidePanelSizes.Small,
        _a));
    var sidebarToggle = classNames(styles.closeButton, (_b = {},
        _b[styles.closeButtonCollapsed] = collapsed,
        _b));
    var dialogContentShade = classNames(styles.dialogContentShade, (_c = {},
        _c[styles.sideBarLockedOpen] = !!props.preventSideBarCollapse,
        _c[styles.shadeVisible] = !collapsed,
        _c));
    var sidebarToggleTitle = collapsed ? 'Open sidebar' : '';
    return (React.createElement(React.Fragment, null,
        React.createElement("aside", { className: sidebarClass },
            props.sidebarRender({ collapsed: collapsed }),
            !props.preventSideBarCollapse && (React.createElement(Button, { testId: 'sidebar-collaspse', mode: ButtonMode.text, title: sidebarToggleTitle, className: sidebarToggle, startIcon: React.createElement(ArrowLeftIcon, { className: styles.sidebarToggleIcon, color: primaryGray }), onClick: props.onToggle },
                React.createElement("div", { className: styles.sidebarToggleText }, "Collapse")))),
        React.createElement("span", { className: dialogContentShade, onClick: props.onToggle })));
};
